module.exports = __webpack_public_path__ + "static/media/mark99_logo.1d99d363.png";